import { FC, memo } from 'react'
import { LocationPickerPassThroughProps } from '../../../common/location-picker/types'
import { SearchbarLocationPickerProps } from '../../../search-result-listing/header-section/searchbar/location-picker/types'
import EventRegionsAutocompleteSuggestionTransport from '../../../../transports/event/event-regions-autocomplete-suggestion-transport'
import { useTranslation } from '../../../../hooks/locale'
import { useEventRegionsGeolocationLocationPicker } from '../../hooks'
import SearchbarLocationPicker from '../../../search-result-listing/header-section/searchbar/location-picker'
import LocationPickerSuggestion from './location-picker/location-picker-suggestion'

type Props = LocationPickerPassThroughProps &
    Pick<
        SearchbarLocationPickerProps<EventRegionsAutocompleteSuggestionTransport>,
        'onLocationInputChange' | 'onLocationItemSelect' | 'onHistoryItemSelect'
    >

const _getSuggestionKey = (item: EventRegionsAutocompleteSuggestionTransport) => item

const RegionsAutocompleteSuggestionPicker: FC<Props> = ({
    isOpen,
    onOpen,
    onClose,
    locationInput,
    onLocationInputChange,
    onLocationInputSelect,
    onLocationItemSelect,
    onHistoryItemSelect,
}) => {
    const { t } = useTranslation()

    const { regionsSuggestions, getRegionSuggestions, setRegionSuggestions } =
        useEventRegionsGeolocationLocationPicker()

    return (
        <SearchbarLocationPicker
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            locationInput={locationInput}
            onLocationInputChange={onLocationInputChange}
            onLocationInputSelect={onLocationInputSelect}
            locationItems={regionsSuggestions}
            getLocationItems={getRegionSuggestions}
            setLocationItems={setRegionSuggestions}
            onLocationItemSelect={onLocationItemSelect}
            onHistoryItemSelect={onHistoryItemSelect}
            locationItemComponent={LocationPickerSuggestion}
            locationInputPlaceholder={t('whereTo')}
            getLocationItemKey={_getSuggestionKey}
        />
    )
}

export default memo(RegionsAutocompleteSuggestionPicker)
